import React from 'react';
import { StyleSheet, View, Text, Image } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Button from 'shared/modules/common/components/atoms/Button';
import APIErrorImg from 'shared/modules/ekyc/assets/images/api-error.png';

type Props = {
  onReturnButtonPress: () => void;
};

const APIError = (props: Props) => {
  const { onReturnButtonPress } = props;
  const isBigScreen = useMediaQuery({ minWidth: 768 });

  return (
    <View style={styles.root}>
      <View style={[styles.imgContainer, !isBigScreen && { paddingTop: 88 }]}>
        <Image source={{ uri: APIErrorImg }} style={styles.img} />
      </View>
      <View style={styles.content}>
        <Text style={styles.mainTitle}>{`エラーが発生しました`}</Text>
        <Text style={styles.subtitle}>{`もう一度お試しください`}</Text>
      </View>

      <View
        style={[
          styles.buttonContainer,
          isBigScreen && styles.buttonContainerBigScreen,
        ]}
      >
        <Button
          title="OK"
          onPress={onReturnButtonPress}
          id="ekyc-api-error-return-button"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  imgContainer: {
    paddingBottom: 24,
  },
  img: {
    height: 184,
    resizeMode: 'contain',
  },
  content: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#000',
    textAlign: 'center',
    marginBottom: 8,
  },
  subtitle: {
    fontSize: 16,
    fontWeight: '300',
    color: '#1C1C1C',
    textAlign: 'center',
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingTop: 12,
  },
  buttonContainerBigScreen: {
    paddingTop: 48,
  },
});

export default APIError;
